define((require) => {
    "use strict";

    const Backbone                  = require("backbone");
    const DuplicateExperienceAction = require("editor/ui/actions/DuplicateExperienceAction");
    const DuplicateGroupAction      = require("editor/ui/actions/DuplicateGroupAction");
    const EditorEvents              = require("shared/services/EditorEvents");
    const GroupModel                = require("shared/ui/groups/GroupModel");
    const ExperienceURLProvider     = require("ui/experience/ExperienceURLProvider");
    const ViewController            = require("editor/util/ViewController");

    /**
     *
     * @class TemplateItemViewController
     *          This class handles both Template Copy and Experience Export
     *
     */
    return ViewController.extend({
        onViewDuplicate: function(experienceModel, triggerOrigin) {
            let action;
            let originalExperienceId;
            if (experienceModel instanceof GroupModel) {
                action = new DuplicateGroupAction(experienceModel, {
                    postfix: "new",
                    projectContext: this.options.projectContext
                });
                originalExperienceId = experienceModel.getSortedAssets()[0].get("id");
            } else {
                action = new DuplicateExperienceAction(experienceModel, {
                    postfix: "new",
                    projectContext: this.options.projectContext
                });
                originalExperienceId = experienceModel.get("id");
            }
            if (!action.executable()) {
                return;
            }
            const eventProperties = {
                templateExperienceId: originalExperienceId,
                triggerOrigin
            };

            let eventTrigger = EditorEvents.constants.EXPORT_EXPORT;
            if (triggerOrigin !== "ExperienceExport") { // actual value is "TemplateItemViewCreateButton"
                eventTrigger = EditorEvents.constants.COPY_TEMPLATE;
            }

            return action
                .execute(eventProperties, eventTrigger)
                .done((experience) => {
                    navigateToUrl(experienceModel, GroupModel, ExperienceURLProvider, experience, Backbone);
                    return experience.get("id");
                });
        }
    });
});


function navigateToUrl(experienceModel, GroupModel, ExperienceURLProvider, experience, Backbone) {
    let urlToNavigateTo;
    if (experienceModel instanceof GroupModel) {
        // If you want to go to the experience URL, then you need to get the URL of the NEW experience
        // OR group..  this is early though so group doesn't yet have internal experience ids
        // experience.getSortedAssets() returns an empty array and I THINK its just an artifact that
        // the eventual DuplicateGroupAction does NOT return here the fully Hydrated Group object,
        // rather just some sort of shell, and worst yet it has the ORIGINAL experience ids
        // which you can extract Object.keys(experience.get("resolvedAssets"))[0]
        // but if you use this to navigate you get a correct and nasty error
        // The save of Desktop (exported) failed because somebody else is modifying the Experience. Make a copy - will not affect this Experience. Refresh - your changes will be lost. Visit the Community
        // as you're trying to view an experience from another account.
        // so it may be possible to get to the first experience_id in the group, its not there now however
        urlToNavigateTo = "#";
    } else {
        urlToNavigateTo = ExperienceURLProvider.provide(experience.get("id"), ExperienceURLProvider.ACTION.EDIT);
    }
    Backbone.history.navigate(urlToNavigateTo, true);
}



// WEBPACK FOOTER //
// ./src/editor/ui/dashboard/TemplateItemViewController.js